var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nightmode",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4294ff",
    d: "M17.75 12a5.736 5.736 0 01-5 5.69 4.718 4.718 0 01-1.5 0 5.738 5.738 0 010-11.38 4.718 4.718 0 011.5 0A5.736 5.736 0 0117.75 12zM12 4.75A.75.75 0 0111.25 4V2a.75.75 0 011.5 0V4A.75.75 0 0112 4.75zM17.657 7.093a.75.75 0 01-.53-1.28L18.541 4.4A.75.75 0 0119.6 5.459L18.188 6.873A.746.746 0 0117.657 7.093zM22 12.75H20a.75.75 0 010-1.5h2a.75.75 0 010 1.5zM19.071 19.821a.749.749 0 01-.53-.219l-1.414-1.414a.75.75 0 011.061-1.061L19.6 18.541a.75.75 0 01-.531 1.28zM12 22.75a.75.75 0 01-.75-.75V20a.75.75 0 011.5 0v2A.75.75 0 0112 22.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd064",
    d: "M4.929 19.821a.75.75 0 01-.531-1.28l1.415-1.414a.75.75 0 011.06 1.061L5.459 19.6A.747.747 0 014.929 19.821zM4 12.75H2a.75.75 0 010-1.5H4a.75.75 0 010 1.5zM6.343 7.093a.742.742 0 01-.53-.22L4.4 5.459A.75.75 0 015.459 4.4L6.873 5.813a.75.75 0 01-.53 1.28zM12.75 6.31V17.69a4.718 4.718 0 01-1.5 0V6.31a4.718 4.718 0 011.5 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd064",
    d: "M12 14.25H7.22a.75.75 0 110-1.5H12a.75.75 0 010 1.5zM12 11.25H7.22a.75.75 0 110-1.5H12a.75.75 0 010 1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd064",
    d: "M12,16.25a4.25,4.25,0,0,1,0-8.5V6.25a5.75,5.75,0,0,0,0,11.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.d871a1d2a6031f3d27845f8a604be5a7.svg";
export { ForwardRef as ReactComponent };